module.exports = __webpack_public_path__ + "static/fipcspottyg1-dd1fa2e6402641276ffbfe02b11b593c.jpeg";